export enum VehicleType {
  PERSONAL_CAR = 'PERSONAL_CAR',
  COMPANY_CAR = 'COMPANY_CAR',
  RENTAL_CAR = 'RENTAL_CAR',
  BUS = 'BUS',
  TRAIN = 'TRAIN',
  AIRPLANE = 'AIRPLANE',
}
